module.exports = __webpack_public_path__ + "assets/d72dcff2c0c21107034b60ab58b2b74c.svg";